<template>
  <section>
    <div v-if="$wait.any" class="loading-wrapper">
      <LoadingBounce />
    </div>
    <CustomModal
      v-if="isNotSupportModal"
      id="not-support-error-modal"
      class="basic-modal no-header-modal hide-cancel-btn content-report-modal"
      :hide-header="true"
      :ok-title="$t('common.confirm')"
      @ok="handleModalCloseClick"
      :isHideCloseButton="true"
    >
      {{ message }}
    </CustomModal>
    <CatNoLicenceModal
      :isOpen="isNoLicenceModal"
      @onCloseClick="handleModalCloseClick"
    />
  </section>
</template>

<script>
import { get, forEach, isArray } from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';

import Mobile from '@/mixins/Mobile';

import CatNoLicenceModal from '../../viewer-cat-pages/components/CatNoLicenceModal';

export default {
  name: 'cat-intro',

  mixins: [
    Mobile,
  ],

  components: {
    CatNoLicenceModal,
  },

  data() {
    return {
      error: {},
      message: '',
      isNotSupportModal: false,
      isNoLicenceModal: false,
    };
  },

  computed: {
    ...mapState({
      catIntro: state => state.viewerCatIntro.catIntro,
    }),

    ...mapGetters({
      routeQuery: 'getRouteQuery',
      isDevice: 'getIsDevice',
    }),
  },

  methods: {
    ...mapActions({
      createCat: 'createCat',
    }),

    handleModalCloseClick() {
      if (this.isClasstingClient) {
        return this.closeWebview();
      }

      return window.close();
    },
  },

  beforeMount() {
    const catParams = {};
    forEach(this.routeQuery, (value, key) => {
      if (key.endsWith('[]')) {
        const newKey = key.slice(0, -2);
        const newValue = isArray(value) ? value : [value];
        catParams[newKey] = newValue;
      } else {
        catParams[key] = value;
      }
    });
    this.createCat(catParams)
      .then(data => this.$router.push(`/viewer/cats/${data.id}`))
      .catch((err) => {
        this.error = err;

        if (this.error.status === 400) {
          this.message = get(this.error, 'data.error_description') || '해당 학년에는 아직 문제가 준비되지 않았어요!';
          this.isNotSupportModal = true;
          return true;
        }

        if (this.error.status === 402 || this.error.status === 403) {
          this.isNoLicenceModal = true;
          return true;
        }

        return true;
      });
  },
};
</script>
